module.exports = __webpack_public_path__ + "img/ic-wavve-big.d25d491b.png";